/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_AttachmentsDTO } from '../models/Routemize_DTOs_AttachmentsDTO';
import type { Routemize_DTOs_AttachmentsDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_AttachmentsDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_CreateAttachmentsDTO } from '../models/Routemize_DTOs_CreateAttachmentsDTO';
import type { Routemize_DTOs_UpdateAttachmentsDTO } from '../models/Routemize_DTOs_UpdateAttachmentsDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AttachmentsService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static postApiAppAttachmentsCreate(
        requestBody?: Routemize_DTOs_CreateAttachmentsDTO,
    ): CancelablePromise<Routemize_DTOs_AttachmentsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/attachments/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppAttachmentsDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/attachments/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static getApiAppAttachmentsGetAttachments(
        entityId: string,
        entityType?: string,
    ): CancelablePromise<Array<Routemize_DTOs_AttachmentsDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/attachments/getAttachments/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static getApiAppAttachmentsGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_AttachmentsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/attachments/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_AttachmentsDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppAttachmentsGetList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/attachments/getList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static putApiAppAttachmentsUpdate(
        requestBody?: Routemize_DTOs_UpdateAttachmentsDTO,
    ): CancelablePromise<Routemize_DTOs_AttachmentsDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/attachments/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppAttachmentsUploadFiles(
        entityId: string,
        entityType?: string,
        formData?: {
            Files?: Array<Blob>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/attachments/uploadFiles/{entityId}',
            path: {
                'entityId': entityId,
            },
            query: {
                'entityType': entityType,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
